module.exports = __webpack_public_path__ + "media/images/meta/digi-wedding-lv-ae36a4b7915c82d65640f2f37942340b.png";